﻿import { createApp } from 'vue'; // reactive, isReactive
import config from "devextreme/core/config";

config({ licenseKey: window.DevExpress.config().licenseKey });

// Import Vue single-file components:
import Sample from './components/sample.vue';

// Make imported components available to mountElement():
const componentRegistry = {
    Sample
};

window.AppVueRegistry = {
    components: componentRegistry,

    /** Mounts a registered Vue component onto a target DOM node.
     * @param {HTMLElement} containerElem - The DOM element to attach Vue to.
     * @param {string} name - Name of the component in componentRegistry. Must match case.
     * @param {Object} props - Initial reactive props to pass to the component.
     * @returns {Object|null} Object containing app and instance properties, along with an unmount method.
     */
    mountElement(containerElem, name, props = {}) {
        const Component = componentRegistry[name];

        if (!Component) {
            return { error: `Component not found.` };
        }

        if (!containerElem) {
            return { error: `Target container element is missing.` };
        }

        const vueContainer = document.createElement('div');
        containerElem.appendChild(vueContainer);

        // const reactiveProps = isReactive(props) ? props : reactive(props);
        const app = createApp(Component, props);
        const instance = app.mount(vueContainer);

        return {
            app,
            instance,
            // reactiveProps,
            unmount: () => app.unmount()
        };
    }
};